import { OfferKindEnum } from '../../../../../services/exports/Constants';

const OfferBadge: Partial<Record<OfferKindEnum, string>> = {
  [OfferKindEnum.PercentageOffByMinSpendValue]: 'Ekstra {{percentageAmount}}% rabat',
  [OfferKindEnum.PercentageOffByProducts]: 'Ekstra {{percentageAmount}}% rabat',
  [OfferKindEnum.AmountOffByProducts]: 'Ekstra {{amount}} i rabat',
  [OfferKindEnum.Bogo]: '2 FOR 1',
  [OfferKindEnum.BogoHalfPrice]: 'Køb 1, få 1 til halv pris!',
  [OfferKindEnum.FreeItemByProducts]: 'Gratis vare',
  [OfferKindEnum.FreeItemByMinSpendValue]: 'Gratis vare',
};

export default OfferBadge;
